import { NOTIFY_ERROR, NOTIFY_SUCCESS } from 'src/vuex/modules/snackbar/types'
import { SPINNER_TYPES } from 'src/vuex/types'
import {
  getCompanyPricingEtr,
  getPartnerPricingEtp,
  getPartnerPricingEtr,
  updateCompanyPricingEtr,
  updatePartnerPricingEtp,
  updatePartnerPricingEtr
} from '../apiCalls'
import texts from '../texts.json'
import * as types from './types'

export default {
  [types.ACTIVATE_EDIT_MODE]: function ({ commit }, value) {
    commit(types.SET_IS_EDIT_MODE, value)
  },
  [types.GET_PRICING_ETP]: async function ({ commit, dispatch }, partnerId) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)
      const pricing = await getPartnerPricingEtp(partnerId)

      commit(types.SET_PRICING, pricing)
      await commit(
        types.SET_SUPPORTED_COUNTRIES,
        Object.keys(pricing.configuration.countries)
      )
      commit(types.SET_PRICING_TO_SAVED, {
        key: null,
        value: pricing.configuration.countries
      })
      commit(types.SET_RECOURSE_TO_SAVED, pricing.configuration.recourse)
    } catch (err) {
      const isConfigNotFound = err.response.status === 404

      // If config is not found, the form should enter in edit mode automatically
      // Any other status is an error
      if (isConfigNotFound) {
        commit(types.SET_IS_CONFIG_NOT_FOUND, true)
        commit(types.SET_IS_EDIT_MODE, true)
      } else {
        console.error(err)
        dispatch(NOTIFY_ERROR, {
          message: texts.pricing_error_message
        })
      }
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  [types.CHANGE_PRICING_TO_SAVED]({ commit }, payload) {
    commit(types.SET_PRICING_TO_SAVED, payload)
  },
  [types.CHANGE_RECOURSE_TO_SAVED]({ commit }, payload) {
    commit(types.SET_RECOURSE_TO_SAVED, payload)
  },
  async [types.UPDATE_PRICING_ETP](
    { commit, dispatch },
    { partnerId, payload }
  ) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)

      await updatePartnerPricingEtp(partnerId, payload)

      await dispatch(types.GET_PRICING_ETP, partnerId)

      commit(types.SET_IS_EDIT_MODE, false)
      commit(types.SET_IS_CONFIG_NOT_FOUND, false)
      dispatch(NOTIFY_SUCCESS, {
        message: 'Pricing updated successfully'
      })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, {
        message: 'Error trying to update pricing'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  [types.CHANGE_IS_CONFIG_NOT_FOUND]: function ({ commit }, newValue) {
    commit(types.SET_IS_CONFIG_NOT_FOUND, newValue)
  },
  [types.GET_PRICING_ETR]: async function ({ commit, dispatch }, partnerId) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)
      const pricing = await getPartnerPricingEtr(partnerId)

      commit(types.SET_PRICING, pricing)
      await commit(
        types.SET_SUPPORTED_COUNTRIES,
        Object.keys(pricing.configuration.countries)
      )
      commit(types.SET_PRICING_TO_SAVED, {
        key: null,
        value: pricing.configuration.countries
      })
      commit(types.SET_RECOURSE_TO_SAVED, pricing.configuration.recourse)
    } catch (err) {
      const isConfigNotFound = err.response.status === 404

      // If config is not found, the form should enter in edit mode automatically
      // Any other status is an error
      if (isConfigNotFound) {
        commit(types.SET_IS_CONFIG_NOT_FOUND, true)
        commit(types.SET_IS_EDIT_MODE, true)
      } else {
        console.error(err)
        dispatch(NOTIFY_ERROR, {
          message: texts.pricing_error_message
        })
      }
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  async [types.UPDATE_PRICING_ETR](
    { commit, dispatch },
    { partnerId, payload }
  ) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)

      await updatePartnerPricingEtr(partnerId, payload)

      await dispatch(types.GET_PRICING_ETR, partnerId)

      commit(types.SET_IS_EDIT_MODE, false)
      commit(types.SET_IS_CONFIG_NOT_FOUND, false)
      dispatch(NOTIFY_SUCCESS, {
        message: 'Pricing updated successfully'
      })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, {
        message: 'Error trying to update pricing'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  async [types.GET_PRICING_COMPANY_ETR]({ commit, dispatch }, companyId) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)

      const pricing = await getCompanyPricingEtr(companyId)

      if (pricing) {
        commit(types.SET_PRICING, pricing)

        if (pricing.overrides && pricing.overrides.countries) {
          await commit(
            types.SET_SUPPORTED_COUNTRIES,
            Object.keys(pricing.overrides.countries)
          )

          commit(types.SET_PRICING_TO_SAVED, {
            key: null,
            value: pricing.overrides.countries
          })
          commit(types.SET_RECOURSE_TO_SAVED, pricing.overrides.recourse)
        }
      }
    } catch (err) {
      console.error(err)
      commit(types.SET_IS_CONFIG_NOT_FOUND, true)

      dispatch(NOTIFY_ERROR, {
        message: 'Error trying to get pricing'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  async [types.UPDATE_PRICING_COMPANY_ETR](
    { commit, dispatch },
    { companyId, payload }
  ) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)

      await updateCompanyPricingEtr(companyId, payload)

      await dispatch(types.GET_PRICING_COMPANY_ETR, companyId)

      commit(types.SET_IS_EDIT_MODE, false)
      commit(types.SET_IS_CONFIG_NOT_FOUND, false)
      dispatch(NOTIFY_SUCCESS, {
        message: 'Pricing updated successfully'
      })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, {
        message: 'Error trying to update pricing'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  }
}
